// src/features/landing/infrastructure/jobPostApiRepository.js

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

/**
 * @param {number} page
 * @param {number} size
 * @param {Object} filters
 * @param {string} [filters.companySido]
 * @param {string} [filters.jobType]
 * @param {string} [filters.sort]
 * @returns {Promise<import("../domain/jobPost").JobPostListResponse>}
 *
 */
async function getJobPosts(page = 0, size = 10, filters = {}) {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
    });

    if (filters.companySido) {
        params.append('companySido', filters.companySido);
    }
    if (filters.jobType) {
        params.append('jobType', filters.jobType);
    }
    if (filters.sort) {
        params.append('sort', filters.sort);
    }

    const response = await fetch(
        `${API_BASE_URL}/api/job-posts?${params.toString()}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (!response.ok) {
        throw new Error('Failed to fetch job posts');
    }

    return response.json();
}

/**
 * @param {number} id
 * @returns {Promise<import("../domain/jobPost").JobPost>}
 */
async function getJobPostById(id) {
    const response = await fetch(
        `${API_BASE_URL}/api/job-posts/${id}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (!response.ok) {
        throw new Error('Failed to fetch job post');
    }

    return response.json();
}

export const jobPostRepository = {
    getJobPosts,
    getJobPostById,
};
